<template>
  <div :class="appClass" id="app">
    <navi v-if="isPC"></navi>
    <sp-navi v-if="isSP"></sp-navi>

    <div v-if="isPC" class="container pc">
      <pc-concept></pc-concept>
      <pc-business></pc-business>
      <pc-company></pc-company>
      <pc-contact></pc-contact>
    </div>

    <div v-if="isSP" class="container sp">
      <sp-concept></sp-concept>
      <sp-business></sp-business>
      <sp-company></sp-company>
      <sp-contact></sp-contact>
    </div>

    <footer-component :device="deviceType" page="concept"></footer-component>
    <loading :loaded="loaded" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import $ from 'jquery'
import Loading from './components/Loading'
import Navi from './components/Navi'
import SpNavi from './components/SpNavi'
import FooterComponent from './components/FooterComponent'
import scrollManager from './lib/scrollManager'
import pcPages from './pages/pc'
import spPages from './pages/sp'
import { isIE, isEdge } from './lib/ua'

export default {
  name: 'App',
  components: {
    Loading,
    Navi,
    SpNavi,
    FooterComponent,
    ...pcPages,
    ...spPages
  },

  data() {
    return {
      loaded: false,
      pageIndex: 0,
      touchPos: 0
    }
  },

  mounted() {
    const routeName = this.$route.name

    if (routeName && routeName.match(/^sp/)) {
      this.setSpDeviceType()
    } else {
      this.setPcDeviceType()
    }
    this.setLoading()

    scrollManager.init((amount) => {
      if (this.$store.state.scrollable) {
        this.$store.commit('setPosition', amount)
      }
    })

    this.handleResize()
  },

  computed: {
    ...mapState(['deviceType']),
    isSP() {
      return this.$store.getters.isSP
    },
    isPC() {
      return this.$store.getters.isPC
    },
    appClass() {
      return {
        sp: this.isSP,
        input: this.$store.state.focusInput,
        edge: isEdge || isIE
      }
    },
    scrolling() {
      return scrollManager.moving
    }
  },

  methods: {
    ...mapMutations(['setSpDeviceType', 'setPcDeviceType']),
    setLoading() {
      setTimeout(() => {
        this.loaded = true
      }, 1000)
    },
    handleResize() {
      $(window)
        .resize(() => {
          const w = window.innerWidth

          if (w < 1000) {
            this.setSpDeviceType()
          } else if (w >= 1000) {
            this.setPcDeviceType()
          }
        })
        .resize()
    }
  }
}
</script>

<style lang="sass">
.scroll-debug
  position: fixed
  top: 20px
  left: 20px

.fade-enter-active, .fade-leave-active
  transition: opacity .2s

.fade-enter-active
  transition-delay: .2s

.fade-enter, .fade-leave-to
  opacity: 0

html, body
  overscroll-behavior: none
  overflow: hidden
  width: 100%
  height: 100%

body
  padding: 0
  margin: 0
  overflow-x: hidden
  background-color: #F0F0EB
  font-family: 'Noto Serif JP', serif
  color: #231815

*
  font-family: 'Noto Serif JP', serif

*
  user-select: none

input, textarea
  user-select: all

.container
  max-width: 1280px
  margin: 0 auto
  &.sp
    max-width: 375px

    .sp-section
      transition: opacity .5s
    .first
      .first
        opacity: 1
      .second
        opacity: 0

    .second
      .first
        opacity: 0.25
      .second
        opacity: 1

::-webkit-scrollbar
  display: none
  -webkit-appearance: none
</style>
